import { render, staticRenderFns } from "./BaseSlide.vue?vue&type=template&id=0d1d739c&scoped=true"
import script from "./BaseSlide.vue?vue&type=script&lang=js"
export * from "./BaseSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1d739c",
  null
  
)

export default component.exports